export function VehicleHighlights({
  highlights,
  getVehicleDetails,
}: {
  highlights: Array<{ carId: string; title: string; reason?: string }>;
  getVehicleDetails: (carId: string) => void;
}) {
  if (!Array.isArray(highlights) || highlights.length === 0) return null;

  return (
    <div className="vcw-highlights">
      {highlights.map((h) => (
        <div key={h.carId} className="vcw-highlight-item">
          <div className="vcw-highlight-title">{h.title}</div>
          <div className="vcw-highlight-reason">{h.reason}</div>
          <button
            type="button"
            className="vcw-highlight-cta"
            onClick={() => getVehicleDetails(h.carId)}
          >
            Voir le véhicule
          </button>
        </div>
      ))}
    </div>
  );
}
